<template>
  <v-card>
    <v-layout column class="pa-4">
      <h2 style="width: 100%; text-align: center;" class="mb-2">Transferência</h2>
      <v-form ref="form" v-model="valid">
        <v-container fluid grid-list-xl>
          <v-layout wrap align-center>
            <v-flex xs12 sm6 d-flex>
              <v-select :items="items" item-value="value" item-text="text" label="Transferir para" v-model="tipo" :rules="requiredRules"></v-select>
            </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select :items="filtros" item-text="text" item-value="value" :rules="requiredRules" label="Pesquisar por" v-model="pesquisa">
            </v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-autocomplete :search-input.sync="campoPesquisa" :readonly="!tipo" :items="objetos.count ? objetos.results : objetos" :item-text="item_text" :item-value="item_value" :rules="requiredRules" label="Destinatário" return-object v-model="destinatario">
            </v-autocomplete>
          </v-flex>
          <v-flex>
            <v-text-field label="Valor de retirada" v-model.lazy="valor" prefix="R$" v-money="money"></v-text-field>
          </v-flex>
          </v-layout>
          <v-layout row>
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!valid || valor_decimal <= 0 || valor_decimal > parseFloat(saldo)" @click="transferirSaldo">Transferir</v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-layout>
  </v-card>
</template>

<script>

import { VMoney } from 'v-money'

export default {
  props: ['saldo'],
  directives: { money: VMoney },
  data () {
    return {
      is_posto: '',
      objetos: '',
      campoPesquisa: 'cnpj',
      destinatario: '',
      valor: 0.00,
      valor_decimal: 0.00,
      item_text: 'cnpj',
      item_value: '',
      valid: false,
      items: [
        { value: 'posto', text: 'Posto' },
        { value: 'empresa', text: 'Empresa' },
        { value: 'cliente', text: 'Cliente' }
      ],
      tipo: 'posto',
      mask: '',
      rules: '',
      pesquisa: 'cnpj',
      filtros: [
        { value: 'cnpj', text: 'CNPJ' },
        { value: 'nome_fantasia', text: 'Nome Fantasia' }
      ],
      requiredRules: [
        v => !!v || 'Este campo é obrigatório'
      ],
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      }
    }
  },
  watch: {
    tipo (value) {
      if (value === 'cliente') {
        this.rules = [
          v => !!v || 'Selecione quem vai receber a transferência de saldo'
        ]
        this.filtros = [
          { value: 'pessoa.nome_completo', text: 'Nome' },
          { value: 'pessoa.cpf', text: 'CPF' }
        ]
        this.pesquisa = 'pessoa.nome_completo'
        this.$store.dispatch('getClientesFiltrados', this.searchData).then((objetos) => {
          this.objetos = objetos
        })
      } else {
        if (value === 'posto') {
          this.rules = [
            v => !!v || 'Selecione o posto que vai receber a transferência de saldo'
          ]
          this.$store.dispatch('getPostosAtivos', this.searchData).then((objetos) => {
            this.objetos = objetos
          })
        } else {
          this.rules = [
            v => !!v || 'Selecione a empresa que vai receber a transferência de saldo'
          ]
          this.$store.dispatch('getEmpresasAtivas', this.searchData).then((objetos) => {
            this.objetos = objetos
          })
        }
        this.filtros = [
          { value: 'cnpj', text: 'CNPJ' },
          { value: 'nome_fantasia', text: 'Nome Fantasia' }
        ]
      }
    },
    valor (value) {
      this.valor_decimal = value
      this.valor_decimal = this.valor_decimal.replaceAll('.', '')
      this.valor_decimal = this.valor_decimal.replace(',', '.')
    },
    pesquisa (value) {
      this.item_text = value
    },
    campoPesquisa (value) {
      if (this.tipo === 'posto') {
        this.$store.dispatch('getPostosAtivos', this.searchData).then((objetos) => {
          this.objetos = objetos
        })
      } else if (this.tipo === 'empresa') {
        this.$store.dispatch('getEmpresasAtivas', this.searchData).then((objetos) => {
          this.objetos = objetos
        })
      } else if (this.tipo === 'cliente') {
        this.$store.dispatch('getClientesFiltrados', this.searchData).then((objetos) => {
          this.objetos = objetos
        })
      }
    }
  },
  methods: {
    transferirSaldo () {
      this.$refs.form.validate()
      if (this.valid) {
        this.$emit('transferirSaldo', { is_posto: this.tipo === 'posto', cpf_receptor: this.destinatario.pessoa ? this.destinatario.pessoa.cpf : null, valor_pago: this.valor_decimal, cnpj_receptor: this.destinatario.cnpj ? this.destinatario.cnpj : null, cnpj_pagador: this.posto.cnpj })
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    searchData () {
      let tempData = {
        filtros: {}
      }
      if (this.campoPesquisa) {
        switch (this.pesquisa) {
          case 'cnpj':
            tempData.filtros['cnpj__icontains'] = this.campoPesquisa
            break
          case 'nome_fantasia':
            tempData.filtros['nome_fantasia__icontains'] = this.campoPesquisa
            break
          case 'pessoa.cpf':
            tempData.filtros['pessoa__cpf__icontains'] = this.campoPesquisa
            break
          case 'pessoa.nome':
            tempData.filtros['pessoa__nome__icontains'] = this.campoPesquisa
            break
        }
      }
      return tempData
    }
  },
  mounted () {
    this.$store.dispatch('getPostosAtivos', this.searchData)
    this.item_text = 'cnpj'
    this.item_value = 'cnpj'
  }
}
</script>
